import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
  padding: 1rem;
  margin: 1rem;
  width: 100%;
  border: 2px dashed ${({ theme }) => theme.colors.uploadBorder};
  background-color: ${({ theme }) => theme.colors.uploadBackground};
`

export const DropContent = styled.div.attrs({ className: 'dropzone' })`
  cursor: pointer;
  width: 100%;
  height: 100%;
  transition: 0.2s ease;
`

export const GridMain = styled(Grid)`
  padding: 0.5rem;
  width: fit-content;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`

export const GridAdditional = styled(Grid)`
  padding: 0.5rem;
`

export const GridIcon = styled(Grid)`
  width: 5rem;
  height: 5rem;
  display: flex;
  vertical-align: middle;
`

export const Title = styled(Grid)`
  color: ${({ theme }) => theme.colors.uploadBorder};
  font-size: 1.5rem;
  font-weight: 400;
`

export const Description = styled.div`
  line-height: 2.3rem;
  font-size: 1.6rem;
  font-weight: 400;
`

export const Additional = styled.div`
  line-height: 2rem;
  font-size: 1.4rem;
`

export const Remove = styled.div`
  /* position: absolute; */
`

export const RemoveFile = styled.label`
  position: relative;
  z-index: 150;
  /* left: 0.5rem; */
`

export const FileBox = styled.div`
  position: absolute;
  border: 1px dashed #000;
`

export const InputFile = styled.input`
  display: none;
`

export const LabelFile = styled.label`
  position: relative;
  z-index: 9;

  &.circle {
    bottom: -4.2rem;
  }

  &.square {
    bottom: -3.1rem;
  }
`
export const WraperImage = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;

  img {
    width: 12.8rem;
    height: 96px;
    object-fit: cover;
    border-radius: 0.4rem;
    background: #dfdada;
    border: 2px solid #fff;
    box-shadow: 0px 3px 6px #00000029;
  }
`

export const LabelPhoto = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.primary};
  height: 1.5rem;
  margin-top: 1.6rem;
`
export const AlertContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const AlertIcon = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.error};

  position: relative;
  bottom: 0.5rem;
  left: 1rem;
  height: 0;
  img {
    height: 1rem;
  }
`

export const AlertText = styled.p`
  color: #de4f4f;
  font-size: 1.2rem;
  font-weight: bold;
  padding-left: 1.5rem;
`

export const PDFContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const PDFName = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
`
